module.exports = "<div *ngIf=\"!errorExist\" class=\"loading no-content\">Loading&#8230;</div>\n"